import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  modalMsg: { type: "", msg: "" },

  pointAffiliateList: {},
  pointAffiliateListPending: false,
  pointAffiliateListSuccess: false,
  pointAffiliateListFailure: false,
  pointAffiliateLinkPending: false,
  pointAffiliateLinkSuccess: false,
  pointAffiliateLinkFailure: false,
  pointLookUpInfo: {},
  pointLookUpPending: false,
  pointLookUpSuccess: false,
  pointLookUpFailure: false,
  pointExchangeResult: {},
  pointExchangePending: false,
  pointExchangeSuccess: false,
  pointExchangeFailure: false,
};
const pointSlice = createSlice({
  name: "point",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },

    // **포인트 - 포인트 교환 페이지 리스트 **
    fetchPointAffiliateList: (state) => {
      state.pointAffiliateListPending = true;
      state.pointAffiliateListSuccess = false;
      state.pointAffiliateListFailure = false;
    },
    fetchPointAffiliateListSuccess: (state, { payload }) => {
      state.pointAffiliateList = payload.data.params;
      state.pointAffiliateListPending = false;
      state.pointAffiliateListSuccess = true;
      state.pointAffiliateListFailure = false;
    },
    fetchPointAffiliateListFailure: (state, { payload }) => {
      state.pointAffiliateListPending = false;
      state.pointAffiliateListSuccess = false;
      state.pointAffiliateListFailure = true;
    },

    // **포인트 - 포인트 교환 - 연동하기 **
    fetchPointAffiliateLink: (state) => {
      state.pointAffiliateLinkPending = true;
      state.pointAffiliateLinkSuccess = false;
      state.pointAffiliateLinkFailure = false;
      state.modalMsg = {
        msg: "",
        type: "",
      };
    },
    fetchPointAffiliateLinkSuccess: (state, { payload }) => {
      state.pointAffiliateLinkPending = false;
      state.pointAffiliateLinkSuccess = true;
      state.pointAffiliateLinkFailure = false;
    },
    fetchPointAffiliateLinkFailure: (state, { payload }) => {
      state.pointAffiliateLinkPending = false;
      state.pointAffiliateLinkSuccess = false;
      state.pointAffiliateLinkFailure = true;
      state.modalMsg = {
        msg: "연동에 실패하였습니다.",
        type: "",
      };
    },

    // **포인트 - 포인트 교환 - 연동하기 **
    fetchPointLookUp: (state) => {
      state.pointLookUpPending = true;
      state.pointLookUpSuccess = false;
      state.pointLookUpFailure = false;
      state.pointLookUpInfo = {};
    },
    fetchPointLookUpSuccess: (state, { payload }) => {
      state.pointLookUpInfo = payload.data.params;
      state.pointLookUpPending = false;
      state.pointLookUpSuccess = true;
      state.pointLookUpFailure = false;
    },
    fetchPointLookUpFailure: (state, { payload }) => {
      state.pointLookUpPending = false;
      state.pointLookUpSuccess = false;
      state.pointLookUpFailure = true;
    },

    // **포인트 - 포인트교환 실행 **
    fetchPointExchange: (state) => {
      state.pointExchangePending = true;
      state.pointExchangeSuccess = false;
      state.pointExchangeFailure = false;
      state.pointExchangeResult = {};
      state.modalMsg = {
        msg: "",
        type: "",
      };
    },
    fetchPointExChangeSuccess: (state, { payload }) => {
      state.pointExchangeResult = payload.data.params;
      state.pointExchangePending = false;
      state.pointExchangeSuccess = true;
      state.pointExchangeFailure = false;
    },
    fetchPointExChangeFailure: (state, { payload }) => {
      state.pointExchangePending = false;
      state.pointExchangeSuccess = false;
      state.pointExchangeFailure = true;
      state.modalMsg = {
        msg: "포인트 교환을 실패하였습니다.",
        type: "",
      };
    },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const pointActions = pointSlice.actions;
export default pointSlice;
